import { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import axiosInstance from '../../../../variables/api/axiosInstance';
import SDIModal from "../../../../components/ui/SDIModal";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AvenantDOrdreEngin = (props) => {
    const [loading, setLoading] = useState(false);
    const [contrat, setContrat] = useState(props.contrat);
    const [modalAvenantOrdre, setModalAvenantOrdre] = useState(props.open);
    const [engin, setEngin] = useState("");
    const [errors, setErrors] = useState([{}]);
    const navigate = useNavigate();

    useEffect(() => {
        const initialEngin = props?.contrat?.engins?.[0];
        setEngin(initialEngin ? { ...initialEngin } : initialEngin);
        setModalAvenantOrdre(props.open);
        setContrat(props.contrat);
    }, [props.open]);

    const handleAssureChange = (e) => {
        const { name, value } = e.target;
        setEngin({ ...engin, [name]: value.toUpperCase() });
    };

    const handleAvenantOrdre = () => {
        if (loading) {
            return;
        }
        if (!engin?.codeId) {
            toast("Aucun engin sélectionné pour l'avenant.");
            return;
        }

        setLoading(true);
        const originalEngin =
            props?.contrat?.engins?.find((item) => item?.codeId === engin?.codeId) || {};

        const parsedNombrePlace = Number.parseInt(engin?.nombrePlace, 10);
        const nombrePlace = Number.isNaN(parsedNombrePlace)
            ? originalEngin?.nombrePlace
            : parsedNombrePlace;

        const resolvedVolumeInput =
            engin?.volume ?? engin?.puissance ?? originalEngin?.volume ?? originalEngin?.puissance;
        const parsedVolume = Number.parseInt(resolvedVolumeInput, 10);
        const volume = Number.isNaN(parsedVolume)
            ? originalEngin?.volume
            : parsedVolume;

        const puissance =
            engin?.puissance ??
            (volume !== undefined && volume !== null ? String(volume) : originalEngin?.puissance);

        const payload = {
            ...originalEngin,
            ...engin,
            nombrePlace,
            volume,
            puissance,
        };

        axiosInstance.put(`/api/contrat/ordre-engin`, payload).then((res) => {
            toast("Informations mises à jour. La prime du contrat sera recalculée automatiquement.");
            props.update(false);
            const redirectCodeId = res?.data?.codeId || contrat?.codeId;
            if (redirectCodeId) {
                navigate(`/details-contrat/${redirectCodeId}`, { replace: true });
            }
        }).catch((err) => {
            console.log(err);
            toast("Erreur lors de l'avenant");
        }).finally(() => setLoading(false));
    }

    const handleCancel = () => {
        setModalAvenantOrdre(false);
        props.update(false);
    };

    return (
        <SDIModal
            title="AVENANT D'ORDRE - ENGIN"
            confirmLoading={loading}
            centered
            open={modalAvenantOrdre}
            onOk={() => handleAvenantOrdre()}
            onCancel={() => handleCancel()}
            width={900}
            zIndex={1500}>
            <form id="addNewAddressForm" className="row">
                <div className="col-12">
                    <div className="alert alert-warning" role="alert">
                        Toute modification de la puissance ou du nombre de places recalculera la prime du contrat après validation de l'avenant.
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="marque">
                                Marque
                            </label>
                            <input
                                type="text"
                                id="marque"
                                name="marque"
                                className={`form-control ${errors?.marque
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez la marque de l'engin"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.marque}
                            />
                            {errors?.marque && (
                                <div className="invalid-feedback">
                                    {errors?.marque}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="nombrePlace">
                                Nombre de place
                            </label>
                            <input
                                type="text"
                                id="nombrePlace"
                                name="nombrePlace"
                                className={`form-control ${errors?.nombrePlace
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez le nombre de place"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.nombrePlace}
                            />
                            {errors?.nombrePlace && (
                                <div className="invalid-feedback">
                                    {errors?.nombrePlace}
                                </div>
                            )}
                            <small className="text-muted d-block mt-1">
                                Si la catégorie l'exige, la prime sera ajustée après validation.
                            </small>
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="moteur">
                                Moteur
                            </label>
                            <input
                                type="text"
                                id="moteur"
                                name="moteur"
                                className={`form-control ${errors?.moteur
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez le numéro du moteur"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.moteur}
                            />
                            {errors?.moteur && (
                                <div className="invalid-feedback">
                                    {errors?.moteur}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="type">
                                Type
                            </label>
                            <input
                                type="text"
                                id="type"
                                name="type"
                                className={`form-control ${errors?.type
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez le type de cet engin"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.type}
                            />
                            {errors?.type && (
                                <div className="invalid-feedback">
                                    {errors?.type}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="immatriculation">
                                Immatriculation
                            </label>
                            <input
                                type="text"
                                id="immatriculation"
                                name="immatriculation"
                                className={`form-control ${errors?.immatriculation
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez l'immatriculation de cet engin"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.immatriculation}
                            />
                            {errors?.immatriculation && (
                                <div className="invalid-feedback">
                                    {errors?.immatriculation}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="numeroChassis">
                                Numero de Châssis
                            </label>
                            <input
                                type="text"
                                id="numeroChassis"
                                name="numeroChassis"
                                className={`form-control ${errors?.numeroChassis
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez le numero de chassis de cet engin"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.numeroChassis}
                            />
                            {errors?.numeroChassis && (
                                <div className="invalid-feedback">
                                    {errors?.numeroChassis}
                                </div>
                            )}
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="genre">
                                Genre du moteur
                            </label>
                            <select
                                id="genre"
                                name="genre"
                                value={engin?.genre}
                                onChange={(e) =>
                                    handleAssureChange(e)
                                }
                                class={`form-control w-100 ${errors?.genre ? "is-invalid" : ""
                                    }`}
                                data-style="btn-default"
                            >
                                <option value="VELOMOTEUR">
                                    Vélomoteur
                                </option>
                                <option value="TRICYCLE">Tricycle</option>
                                <option value="MOTOCYCLETTE">
                                    Motocyclette
                                </option>
                                <option value="CYCLOMOTEUR">
                                    Cyclomoteur
                                </option>
                            </select>
                            {errors?.genre && (
                                <div className="invalid-feedback">
                                    {errors?.genre}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="numeroChassis">
                                Volume (ou Puissance)
                            </label>
                            <input
                                type="number"
                                id="volume"
                                name="volume"
                                className={`form-control ${errors?.volume
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez le volume (ou puissance) de cet engin"
                                onChange={(e) => handleAssureChange(e)}
                                value={engin?.volume || parseInt(engin?.puissance || 0) || 0}
                            />
                            {errors?.volume && (
                                <div className="invalid-feedback">
                                    {errors?.volume}
                                </div>
                            )}
                            <small className="text-muted d-block mt-1">
                                Modifier la puissance entraîne un recalcul automatique de la prime.
                            </small>
                        </div>
                    </div>
                </div>
            </form>
        </SDIModal>
    )
}

AvenantDOrdreEngin.propTypes = {
    open: PropTypes.bool,
    update: PropTypes.func,
    contrat: PropTypes.object
}

export default AvenantDOrdreEngin
